import { render, staticRenderFns } from "./formEdit.vue?vue&type=template&id=e6470a9e&scoped=true"
import script from "./formEdit.vue?vue&type=script&lang=js"
export * from "./formEdit.vue?vue&type=script&lang=js"
import style0 from "./formEdit.vue?vue&type=style&index=0&id=e6470a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6470a9e",
  null
  
)

export default component.exports